import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { setSchedaCoopAgricoleStabilimentoListeners } from './scheda-coop-agricole-stabilimento.listeners';

export class SchedaCoopAgricoleFormListeners extends FormListeners {
    private readonly store: Store<Revisione53State>;

    constructor(form: FormGroup, store: Store<Revisione53State>) {
        super(form);
        this.store = store;
    }

    setListeners(): void {
        setSchedaCoopAgricoleStabilimentoListeners(this.form, this.store);
    }
}
